import { useSelector } from 'react-redux'

const useTranslation = () => {
  const { locale, dictionary } = useSelector((state) => state.i18nL10n)

  return (key, defaultValue) => {
    if (dictionary && dictionary[locale] && dictionary[locale][key]) {
      return dictionary[locale][key]
    } else {
      return defaultValue || key
    }
  }
}

export default useTranslation
